export default __webpack_public_path__ + "static/media/download.2cfb6a1d.svg";